import request from '@/utils/request'

// 顶部数据展示
export function topData (params) {
  return request({
    url: '/v1/device/category/list',
    method: 'get',
    params
  })
}

// 获取设备坐标
export function allDevice (params) {
  return request({
    url: '/v1/device/info/list',
    method: 'get',
    params
  })
}

// 更新停车场数据接口
export function updateDevice () {
  return request({
    url: '/v1/device/info/list',
    method: 'get'
  })
}
